/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fuehrungzeugniseinsichtnahmeerfolgt2Inputs */

const de__field_fuehrungzeugniseinsichtnahmeerfolgt2 = /** @type {(inputs: _Field_Fuehrungzeugniseinsichtnahmeerfolgt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsichtnahme in Führungszeugnis ist erfolgt`)
};

/**

* @param {_Field_Fuehrungzeugniseinsichtnahmeerfolgt2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fuehrungzeugniseinsichtnahmeerfolgt2 = /** @type {((inputs?: _Field_Fuehrungzeugniseinsichtnahmeerfolgt2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fuehrungzeugniseinsichtnahmeerfolgt2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_fuehrungzeugniseinsichtnahmeerfolgt2(inputs)
});
export { _field_fuehrungzeugniseinsichtnahmeerfolgt2 as "_field_fuehrungzeugnisEinsichtnahmeErfolgt" }